
import React from 'react';

import BetslipPopupRegistered from './BetslipPopupBarcode';
import BetslipPopupClipboard from './BetslipPopupClipboard';
import BetslipPopupCode from './BetslipPopupCode';
import Icon from 'src/components/Icon/Icon';
import BetslipPopupMessage from './BetslipPopupMessage';
import './BetslipPopup.scss';

interface BetslipPopupProps {
  children?: React.ReactNode,
  onClose?: () => void,
  title?: string
}

function BetslipPopup({ children, onClose, title }: BetslipPopupProps) {
  return (
    <>
      <div className="betslip-popup__bg"></div>
      <div className="betslip-popup">
        <div className="betslip-popup__header">
          { title }
          <Icon
            icon="close"
            className="betslip-popup__close"
            onClick={ onClose }
          />
        </div>
        { children }
      </div>
    </>
  );
}

BetslipPopup.BetRegistered = BetslipPopupRegistered;
BetslipPopup.Clipboard = BetslipPopupClipboard;
BetslipPopup.Code = BetslipPopupCode;
BetslipPopup.Message = BetslipPopupMessage;

export default BetslipPopup;
